export default {
  buttonStyle: {
    width: "150px",
    height: "33px",
    marginBottom: "20px",
    marginTop: "20px",
  },
};
